import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/style.css";
import logo from "../../../assets/images/inc-policy-logo.png";

import imgCustomer from "../../../assets/images/audience-svgrepo-com.svg";
import imgUsers from "../../../assets/images/group-people-svgrepo-com.svg";
// import imgDeviceProfile from "../../../assets/images/laptop-svgrepo-com.svg";
import imgDevices from "../../../assets/images/devices-smartphone-svgrepo-com.svg";
// import imgRuleChains from "../../../assets/images/chain-hyperlink-interface-svgrepo-com.svg";
// import imgRuleEngine from "../../../assets/images/settings-cogwheel-svgrepo-com.svg";
import imgDashboards from "../../../assets/images/dashboard-alt-svgrepo-com.svg";
// import imgAssets from "../../../assets/images/wallet-svgrepo-com.svg";

import imgPrivacy from "../../../assets/images/privacy-svgrepo-com.svg";
import imgTerms from "../../../assets/images/policy-term.svg";
import imgLicense from "../../../assets/images/license-svgrepo-com.svg";

// import imgRestApi from "../../../assets/images/rest-api.png";
// import imgNodeApi from "../../../assets/images/api-code.svg";
// import imgCoapApi from "../../../assets/images/coap-api.png";

const HelpPage = () => {
  const navigate = useNavigate();

  const features = [
    // { label: "Customer", icon: imgCustomer, route: "/public/customers" },
    { label: "User Registration", icon: imgUsers, route: "/public/users" },
    { label: "Devices", icon: imgDevices, route: "/public/device" },
    // { label: "Device Agent", icon: imgRuleEngine },
    { label: "Device Simulator", icon: imgDashboards, route: "/public/device-simulator" },
    // { label: "Edge Gateway", icon: imgAssets },
  ];

  const agreements = [
    {
      label: "Privacy Policy",
      icon: imgPrivacy,
      route: "/public/privacyPolicy",
    },
    {
      label: "Terms of Use",
      icon: imgTerms,
      route: "/public/terms-of-use",
    },
    {
      label: "User License",
      icon: imgLicense,
      route: "/public/userLicense", // updated to use route
    },
  ];

  //   const apiDocs = [
  //     { label: "INC API", icon: imgRestApi },
  //     { label: "Node API", icon: imgNodeApi },
  //     { label: "P2P COAP API", icon: imgCoapApi },
  //   ];

  const Section = ({ title, items }) => (
    <>
      <h3 className="heading">{title}</h3>
      <div className="four-grid">
        {items.map((item, index) => (
          <div
            key={index}
            className="helpdiv"
            onClick={() => {
              if (item.route) {
                navigate(item.route);
              } else if (item.pdfPath) {
                window.open(item.pdfPath, "_blank");
              }
            }}
            style={{
              cursor: item.route || item.pdfPath ? "pointer" : "default",
            }}
          >
            <div className="helpimage">
              <img src={item.icon} alt={item.label} />
            </div>
            <h3>{item.label}</h3>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <Section title="Features" items={features} />
          <Section title="Agreements" items={agreements} />
          {/* <Section title="API Documentations" items={apiDocs} /> */}
        </div>
      </div>

      <footer>
        <div className="container">
          Powered by{" "}
          <a
            href="https://www.vvdntech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            VVDN Technologies
          </a>
        </div>
      </footer>
    </>
  );
};

export default HelpPage;
